import type { FaireProductEntity } from "../../entity_types/product";

export const p_1upyul03mt: FaireProductEntity = {
  token: "p_1upyul03mt",
  type: "product",
  name: "Trolleite Cat Kitty Face, Crystal Cat",
  brandToken: "b_en1yij2pf6",
  brandName: "Natures Artifacts Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/7190849561bd2f19393ae72a5b834b62c729e7944e8fcfb3e9de1d0df5858d5f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c7ebc2450fdce3aef5c747d3cff265b3c17e4ec0e44c8f1bbf48db85c8e611f4.jpeg",
    "https://cdn.faire.com/fastly/60a1a8fa4a08be3b949a309def52b74c87fca921711e4a2809a89708c61d2eea.jpeg",
    "https://cdn.faire.com/fastly/28e8f735cfc3aff366180e39458e08eedac315d67fcd59c366b022886bd95610.jpeg",
    "https://cdn.faire.com/fastly/15042e0d31dfd330a2770e1e8c36975925f014c104a6d47385b8b5406bf8dc16.jpeg",
    "https://cdn.faire.com/fastly/23e48769f52efb235015128c0696ee7ed16f050e014b729efcb8f6c4c43b157a.jpeg",
    "https://cdn.faire.com/fastly/9049892cbb20effcbd4945e8224a2e84486089a80562a5842fbb8eda8c626cfd.jpeg",
  ],
  priceDollars: 5.2,
  description:
    'These beautiful crystal animal faces form an ideal visual meditation practice. Genuine gemstone kitty face, hand-carved in Brazil.  Approx. 1" in size.\nDue to the nature of the stone and hand carving, the sizes may vary.',
  tags: [],
  msrpDollars: 10.39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:04.240Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
